import { render, staticRenderFns } from "./InputfieldRadio.vue?vue&type=template&id=0985dd86&scoped=true&"
import script from "./InputfieldRadio.vue?vue&type=script&lang=js&"
export * from "./InputfieldRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0985dd86",
  null
  
)

export default component.exports